/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeHeroSectionData } from './moe-hero-section.data';
import { IMoeHeroSectionProps } from './moe-hero-section.props.autogenerated';

export interface IMoeHeroSectionViewProps extends IMoeHeroSectionProps<IMoeHeroSectionData> {}

/**
 *
 * MoeHeroSection component
 * @extends {React.PureComponent<IMoeHeroSectionProps<IMoeHeroSectionData>>}
 */
class MoeHeroSection extends React.PureComponent<IMoeHeroSectionProps<IMoeHeroSectionData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeHeroSection;
